import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export async function startCheckout(lookup_key) {
  try {
    const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin });
    window.location.href = data.checkout_url;
  } catch (e) {
    toast.error(formatApiError(e?.response?.data?.detail) || "Could not start checkout");
  }
}

// Polls payment status after Stripe redirects back with ?session_id=...
export function usePaymentReturn(onPaid) {
  const [params, setParams] = useSearchParams();
  const [status, setStatus] = useState(null);
  const done = useRef(false);
  const sid = params.get("session_id");
  const cancelled = params.get("cancelled");

  useEffect(() => {
    if (cancelled) { toast("Checkout cancelled — you were not charged"); setParams({}, { replace: true }); }
  }, [cancelled, setParams]);

  useEffect(() => {
    if (!sid || done.current) return;
    done.current = true;
    let tries = 0;
    setStatus("checking");
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid"); toast.success("Payment confirmed — thank you!"); onPaid?.();
          setParams({}, { replace: true }); return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setStatus("failed"); toast.error("Payment was not completed"); setParams({}, { replace: true }); return;
        }
      } catch {}
      if (++tries < 15) setTimeout(poll, 2000); else { setStatus("timeout"); toast("Still processing — your coins will appear shortly"); }
    };
    poll();
  }, [sid]); // eslint-disable-line react-hooks/exhaustive-deps

  return status;
}
